import { useEffect, useState, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import CustomSlider from "../../customSlider/CustomSlider";

import { LoadingDot } from "../../UI/spinners/LoadingSpinners";
import { getCategoryInfos } from "../../Map/utils";
import {
  EnvironmentalDataContext,
  HydroDataContext,
  MeteoInfoDataContext,
} from "../../../hooks/context";
import { useAllContexts } from "../../../hooks/useAllContexts";
import { useTranslation } from "react-i18next";

const Meteor = ({ typeId, title, type, group }) => {
  const [categoryData, setCategoryData] = useState(null);
  const { environment, bins, hum } = useAllContexts();
  const { t } = useTranslation();

  const { meteoInfoData, meteoLoading } = useContext(MeteoInfoDataContext);
  const { hydroData, hydroLoading } = useContext(HydroDataContext);
  const { environmentalData, environmentalLoading } = useContext(
    EnvironmentalDataContext,
  );

  useEffect(() => {
    setCategoryData(getCategoryInfos(typeId));
  }, []);

  const handleDate = (timestamp) => {
    const timestampToDate = new Date(timestamp * 1000);

    const addZero = (value) => (value < 10 ? `0${value}` : value);

    return `${addZero(timestampToDate.getDay())}/${addZero(
      timestampToDate.getUTCMonth(),
    )}/${timestampToDate.getFullYear()} ${addZero(
      timestampToDate.getHours(),
    )}:${addZero(timestampToDate.getMinutes())}:${addZero(
      timestampToDate.getSeconds(),
    )}`;
  };

  const renderProblem = () => {
    return (
      <p
        style={{
          fontWeight: "600",
          fontSize: "14px",
          paddingTop: "10px",
          color: "#333",
        }}
      >
        Αδυναμία λήψης δεδομένων λόγω προβλήματος
      </p>
    );
  };

  const renderItems = (start, end, items) => {
    const tempItems = [];
    for (let itemIndex = start; itemIndex < end; itemIndex++) {
      tempItems.push(items[itemIndex]);
    }

    console.log("TEMP ITEMS:", tempItems);

    return tempItems.map((item, index) => {
      return (
        <div key={`${item.group_name}_index`}>
          <BoxEntity
            key={index}
            icon={`https://korydallos.smartiscity.gr/gallery/vars/Small/${item.sensorvar_icon}`}
            content={item.group_name}
            value={`${parseInt(item.group_val).toFixed(2)} ${
              item.sensorvar_unit
            }`}
            // date={item.date_insert}
          />
        </div>
      );
    });
  };

  return (
    <>
      {/* {loading && <LoadingDot />} */}
      <BoxTitle
        icon={`im ${categoryData?.icon}`}
        title={title}
        link={`/map?typeId=${typeId}`}
        infoContext={t(`${type}.tooltip`)}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
        id={typeId}
      />
      {typeId === "5" &&
        (meteoInfoData?.length > 0 ? (
          <CustomSlider>
            {meteoInfoData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  {/* <BoxSubTitle>Bόλος</BoxSubTitle> */}
                  <BoxSubTitle style={{ fontWeight: "600" }}>
                    {t(`environmental.areaNames.${infoItem?.sensor_address}`)}
                  </BoxSubTitle>
                  {infoItem.details.map((infoDetail, index) => {
                    return (
                      <BoxEntity
                        key={index}
                        icon={`https://korydallos.smartiscity.gr/gallery/vars/Small/${infoDetail.sensorvar_icon}`}
                        // content={infoDetail.sensorvar_description}
                        content={t(
                          `dataNames.${infoDetail.sensorvar_icon.slice(
                            0,
                            infoDetail.sensorvar_icon.indexOf("."),
                          )}`,
                        )}
                        value={[
                          infoDetail.sensorvar_icon.includes("29")
                            ? infoDetail.measurement
                            : parseFloat(infoDetail.measurement).toFixed(2) ??
                              null,
                          infoDetail.sensorvar_icon.includes("29")
                            ? null
                            : infoDetail.sensorvar_unit,
                        ]}
                        // value={[
                        //   parseFloat(infoDetail.measurement).toFixed(2),
                        //   infoDetail.sensorvar_unit,
                        // ]}
                        date={infoDetail.date_insert}
                      />
                    );
                  })}
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
      {typeId === "1" && !environmentalData && <LoadingDot />}
      {typeId === "1" &&
        (environmentalData ? (
          <CustomSlider>
            {environmentalData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  <BoxSubTitle>
                    {t(`environmental.areaNames.${infoItem?.mysensor_name}`)}
                  </BoxSubTitle>
                  <div
                    style={{
                      width: "100%",
                      height: "420px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    {infoItem?.details.map((infoDetail, index) => {
                      return (
                        <BoxEntity
                          key={`map_${index}`}
                          icon={
                            infoDetail.sensorvar_icon.includes("unknown")
                              ? ``
                              : `https://volos.smartiscity.gr/gallery/vars/Small/${infoDetail.sensorvar_icon}`
                          }
                          content={t(`dataNames.${infoDetail.sensorvar_id}`)}
                          value={[
                            infoDetail.sensorvar_icon.includes("29")
                              ? infoDetail.measurement
                              : parseFloat(infoDetail.measurement).toFixed(2) ??
                                null,
                            infoDetail.sensorvar_icon.includes("29")
                              ? null
                              : infoDetail.sensorvar_unit,
                          ]}
                          // date={handleDate(infoDetail.timestamp)}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          environment?.environmentalData?.length === 0 && renderProblem()
        ))}
      {typeId === "6" && !hydroData && <LoadingDot />}
      {typeId === "6" &&
        (hydroData ? (
          <CustomSlider>
            {hydroData?.map((infoItem, index) => {
              return (
                <div key={index}>
                  <BoxSubTitle>
                    {t(`environmental.areaNames.${infoItem?.sensor_address}`)}
                  </BoxSubTitle>
                  <div
                    style={{
                      width: "100%",
                      height: "420px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {infoItem?.details.map((infoDetail, index) => {
                      return (
                        <BoxEntity
                          key={`map_${index}`}
                          icon={`https://patra.smartiscity.gr/gallery/vars/Small/${infoDetail.sensorvar_icon}`}
                          content={t(
                            `dataNames.${infoDetail.sensorvar_icon.slice(
                              0,
                              infoDetail.sensorvar_icon.indexOf("."),
                            )}`,
                          )}
                          value={[
                            parseFloat(infoDetail.measurement).toFixed(2) ??
                              infoDetail.measurement,
                            infoDetail.sensorvar_unit ?? null,
                          ]}
                          // date={handleDate(infoDetail.timestamp)}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </CustomSlider>
        ) : (
          environment?.environmentalData?.length === 0 && renderProblem()
        ))}
      {typeId === "12" &&
        (hum ? (
          <CustomSlider>
            {hum?.humData && renderItems(0, 8, hum?.humData?.group)}
            {
              // hum?.humData.group.map((infoItem, index) => {
              //   return (
              //     <BoxEntity
              //       key={index}
              //       icon={`im im-icon-On-Off-3`}
              //       content={infoItem.group_name}
              //       value={`${parseInt(infoItem.group_val).toFixed(2)} ${
              //         infoItem.sensorvar_unit
              //       }`}
              //     />
              // <div key={index}>
              //   {/* <BoxSubTitle>{infoItem.group_name}</BoxSubTitle> */}
              //   {/* {infoItem.details.map((infoDetail, index) => {
              //     return (
              //     );
              //   })} */}
              // </div>
              //   );
              // })
            }
          </CustomSlider>
        ) : (
          renderProblem()
        ))}
    </>
  );
};

export default Meteor;
